<template>
<div class="page-container">
  <el-breadcrumb separator="/">
    <el-breadcrumb-item>
      <span class="page-title">系统设置</span>
    </el-breadcrumb-item>
    <el-breadcrumb-item>币种介绍设置</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card class="page-content" shadow="never">
    <div class="page-actions">
      <create-currency-introduction @refresh="refreshList"></create-currency-introduction>
      <el-input placeholder="请输入币种" clearable v-model="query" @keyup.enter.native="handleSearch()">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
    <currency-introduction-list @refresh="refreshList"></currency-introduction-list>
  </el-card>
</div>
</template>

<script>
import CurrencyIntroductionList from './components/list';
import CreateCurrencyIntroduction from './components/create';
import './store';
import { mapActions, mapState } from 'vuex';
import { PAGINATION } from 'common/config';

export default {
  name: 'CurrencyIntroduction',
  data() {
    return {
      query: ''
    };
  },
  components: {
    CurrencyIntroductionList,
    CreateCurrencyIntroduction
  },
  computed: {
    ...mapState('currencyIntroductionSetting', ['pagination'])
  },
  methods: {
    ...mapActions('currencyIntroductionSetting', ['list']),
    refreshList(data = {}) {
      this.list({
        query: this.query,
        ...this.pagination,
        ...data
      });
    },
    handleSearch() {
      this.list({
        query: this.query,
        ...this.pagination,
        page: 1
      });
    }
  },
  created() {
    this.list({
      query: this.query,
      ...PAGINATION
    });
  }
}
</script>

<style lang="less" scoped>

</style>
